// extracted by mini-css-extract-plugin
export default {"documentCard":"DocumentCard_documentCard__I5kvA","compact":"DocumentCard_compact__8RFVi"};